export const CHART_TYPES = ['graph', 'map'];
